export const VISIBILITY_VISIBLE = true
export const VISIBILITY_NOT_VISIBLE = false
export const VISIBILITY_EXISTING_INSTALL = 'existing-install'
